import { createRoutine } from 'redux-saga-routines';

export const fetchInventoryLocationOptions = createRoutine(
  'FETCH_INVENTORY_LOCATION_OPTIONS'
);

export const fetchInventoryLocationZoneOptions = createRoutine(
  'FETCH_INVENTORY_LOCATION_ZONE_OPTIONS'
);

export const fetchInventoryDonorOptions = createRoutine(
  'FETCH_INVENTORY_DONOR_OPTIONS'
);

export const adjustInventoryItem = createRoutine('ADJUST_INVENTORY_ITEM');

export const adjustInventoryPackage = createRoutine('ADJUST_INVENTORY_PACKAGE');
